import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";

export default function P400() {
    const history = useHistory();

    const handlerAction = (page) => {
        // history.push(`/${page}`);
        // if301
        history.push({
            pathname: page,
            state: {
                from: 400
            },
        });
    };

    const [data] = useState({ userInfo: dataUserSession() ? dataUserSession() : {}, });


    return (
        <>
            <div className="layout-dashboard" style={{ marginTop: '5%' }}>
                <div className="p-grid">
                    {/* <div className="p-col-12 p-lg-1 p-md-12 p-sm-12"></div> */}
                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                        <a href onClick={() => handlerAction("402")}>
                            <div className="overview-box item10 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <i className="pi pi-briefcase" style={{ fontSize: "30px", marginTop: '5px' }} />
                                <p style={{ fontSize: '22px', marginTop: '5px' }}>บริษัทคู่สัญญา</p>
                            </div>
                        </a>
                    </div>

                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                        <a href onClick={() => handlerAction("411")}>
                            <div className="overview-box item10 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <i className="pi pi-file" style={{ fontSize: "30px", marginTop: '5px' }} />
                                <p style={{ fontSize: '22px', marginTop: '5px' }}>สัญญาก่อสร้าง</p>
                            </div>
                        </a>
                    </div>

                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                        <a href onClick={() => handlerAction("419")}>
                            <div className="overview-box item10 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <i className="pi pi-minus" style={{ fontSize: "30px", marginTop: '5px' }} />
                                <p style={{ fontSize: '22px', marginTop: '5px' }}>ลงแนวเส้นท่อใน GIS</p>
                            </div>
                        </a>
                    </div>

                    {/* <div className="p-col-12 p-lg-4 p-md-6 p-sm-12"></div> */}
                    {/* <div className="p-col-12 p-lg-2 p-md-2 p-sm-2"></div> */}

                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                        <a href onClick={() => handlerAction("301")}>
                            <div className="overview-box item10 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <i className="pi pi-th-large" style={{ fontSize: "30px", marginTop: '5px' }} />
                                <p style={{ fontSize: '22px', marginTop: '5px' }}>Dashboard ผู้บริหาร</p>
                            </div>
                        </a>
                    </div>

                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                        <a href onClick={() => handlerAction("401")}>
                            <div className="overview-box item10 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <i className="pi pi-users" style={{ fontSize: "30px", marginTop: '5px' }} />
                                <p style={{ fontSize: '22px', marginTop: '5px' }}>ผู้ใช้งานในระบบ</p>
                            </div>
                        </a>
                    </div>




                </div>

                {
                    (data.userInfo && (data.userInfo.userBranchCode === '' || data.userInfo.userBranchCode === null)) ?
                        (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                    <hr style={{ width: '70%' }} />
                                </div>

                                <div className="p-grid" style={{ marginTop: '20px' }}>
                                    {/* <div className="p-col-12 p-lg-2 p-md-2 p-sm-2"></div> */}
                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("404")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-link" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>ลักษณะงาน</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("405")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-reply" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>งานสั่งการเฉพาะอย่าง</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("410")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-list" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>หลักเกณฑ์การประเมิน</p>
                                            </div>
                                        </a>
                                    </div>

                                    {/* <div className="p-col-12 p-lg-1 p-md-6 p-sm-12"></div> */}
                                    {/* <div className="p-col-12 p-lg-2 p-md-6 p-sm-12"></div> */}

                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("100")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-th-large" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>Dashboard ผู้รับเหมา</p>
                                            </div>
                                        </a>
                                    </div>

                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("200")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-th-large" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>Dashboard ผู้ควบคุมงาน</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("420")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-pencil" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>เฉดสีแสดงความก้าวหน้าของงานบน GIS</p>
                                            </div>
                                        </a>
                                    </div>

                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("421")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-camera" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>ข้อมูลกล้อง CIA</p>
                                            </div>
                                        </a>
                                    </div>
{/* 
                                    <div className="p-col-12 p-lg-4 p-md-6 p-sm-12">
                                        <a href onClick={() => handlerAction("CIA")}>
                                            <div className="overview-box item9 cursor-mo" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <i className="pi pi-camera" style={{ fontSize: "30px", marginTop: '5px' }} />
                                                <p style={{ fontSize: '22px', marginTop: '5px' }}>ข้อมูลกล้องจากระบบ CIA</p>
                                            </div>
                                        </a>
                                    </div> */}
                                </div>
                            </>
                        ) :
                        ('')
                }
            </div>
            {/*  */}
        </>
    );
}
